import PropTypes from "prop-types";
import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { selectEmpleados } from "../../../Personas/services/empleados-service";
import { asignarSolicitud, reAsignarSolicitud } from "../../services/solicitudes-soporte-service";

const FormAsignacion = ({ modalState, onSave }) => {
    const { solicitud } = modalState.data;
    const [empleados, setEmpleados] = useState([]);

    useEffect(async () => {
        const resp = await selectEmpleados();
        if (!resp.status) return toast.error(resp.message);
        setEmpleados(resp.data);
    }, []);

    const campos = {
        solicitud_id: solicitud.id,
        empleados: solicitud.empleados != null ? solicitud.empleados : [],
        observacion: "",
    };

    const form = useForm({
        defaultValues: campos,
    });

    useEffect(() => {
        form.reset(campos);
    }, [solicitud.id]);

    const onCreateAsignacion = async (asignar) => {
        if (modalState.data.tipo == "asignar") {
            const resp = await asignarSolicitud({
                ...asignar,
                personasAsignadas: asignar.empleados.map((personaAsignada) => personaAsignada.value)
            });
            if (!resp.status) return toast.error(resp.message);

            toast.success(resp.message);
            modalState.close();
            onSave();
        }else{
            const resp = await reAsignarSolicitud({
                ...asignar,
                personasAsignadas: asignar.empleados.map((personaAsignada) => personaAsignada.value)
            });

            if (!resp.status) return toast.error(resp.message);
            toast.success(resp.message);
            modalState.close();
            onSave();
        }
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formAsignacion"
            isOpen={modalState.show}
            onSubmit={onCreateAsignacion}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <Col sm={6}>
                    <InputController
                        label="Solicitud"
                        name="solicitud_id"
                        control={form.control}
                        errors={form.formState.errors}
                        readOnly={true}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        label="Colaborador"
                        name="empleados"
                        isMulti={true}
                        errors={form.formState.errors}
                        control={form.control}
                        rules={{
                            required: "Este campo es requerido",
                        }}
                        options={empleados.map((empleado) => {
                            return {
                                label: empleado.info_persona,
                                value: empleado.id,
                            };
                        })}
                    />
                </Col>
                <Col sm={12}>
                    <InputController
                        type="textarea"
                        name="observacion"
                        label="Observación"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Observación"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormAsignacion.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func,
};

export default FormAsignacion;
